import { useState, useEffect } from "react";
import AddDriverModal from "../../modals/add-driver-modal";
import { getDrivers } from "../../api/services";
import LoadingModalComponent from "../../modals/loading-modal";
import CustomPagination from "../../components/pagination";
import { useSearchParams } from "react-router-dom";
import CustomSearch from "../../components/search";
import { driverSearchTypes } from "../../configs/searchTypes";

export default function DriverListScreen() {
  const [showAddDriverModal, setShowAddDriverModal] = useState();
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const DRIVERS_PER_PAGE = 12;
  const page = searchParams.get("page") || 1;
  const phone = searchParams.get("phone") || null;
  const car = searchParams.get("car") || null;

  useEffect(() => {
    setLoading(true);
    getDrivers({ phone, car, limit: DRIVERS_PER_PAGE, offset: (page - 1) * DRIVERS_PER_PAGE })
      .then((res) => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [phone, car, page]);

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <LoadingModalComponent show={loading} />
          <AddDriverModal
            show={showAddDriverModal}
            onHide={() => setShowAddDriverModal(false)}
            setShow={setShowAddDriverModal}
          />
          <div className="card-body">
            <div className="row mb-2 d-flex justify-content-between">
              <div className="col-4">
                <CustomSearch searchTypes={driverSearchTypes} placeholder={"Жолооч хайх..."} />
              </div>
              <div className="col-2 text-end">
                <button
                  className="btn btn-success"
                  type="button"
                  onClick={() => setShowAddDriverModal(true)}
                >
                  <i className="uil-plus-circle me-2"></i>
                  <span>Нэмэх</span>
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-bordered mb-0">
                <thead>
                  <tr className="text-center">
                    <th className="fw-normal col-1">#</th>
                    <th className="fw-normal col">Утасны дугаар</th>
                    <th className="fw-normal col">Машины дугаар</th>
                    <th className="fw-normal col">Тэмдэглэл</th>
                    <th className="fw-normal col">Бүртгүүлсэн огноо</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.data.map((k, i) => (
                    <tr key={i} className="text-center">
                      <td>{i + 1}</td>
                      <td>{k.phone}</td>
                      <td>{k.car_num}</td>
                      <td>{k.add_info}</td>
                      <td>{k.createdAt}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <CustomPagination total={data?.total} limit={DRIVERS_PER_PAGE} />
          </div>
        </div>
      </div>
    </div>
  );
}
